import './Tag.scss';
import * as React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { slugForString } from 'utils/strings';
type Props = {
  tag: string;
  current?: boolean | null;
};
const colors = [
  'accent-color-one',
  'accent-color-two',
  'accent-color-three',
  'accent-color-four',
  'accent-color-five',
  'accent-color-six',
  'accent-color-seven',
  'accent-color-eight',
];

/**
 Pick a randomized color name for a tag string, returning the same color each
 time for the same tag.
 */
function colorForTag(tag: string): string {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = ((hash << 1) - hash + tag.charCodeAt(i)) << 0;
  }
  return colors[Math.abs(hash) % colors.length];
}
export default class Tag extends React.Component<Props> {
  static defaultProps = {
    current: false,
  };
  render() {
    const { tag, current } = this.props;
    const color = colorForTag(tag);
    return (
      <Link
        className={classnames(`DocsTag DocsTag--${color}`, {
          'DocsTag--current': current,
        })}
        to={`/docs/tag/${slugForString(tag)}/`}
      >
        {tag}
      </Link>
    );
  }
}
